import { Icon, IconProps } from "../";

export const DummyIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M3 9.33293V7.21161L7.21161 3H9.33293L3 9.33293Z" />
      <path d="M3 13.5756V11.4543L11.4543 3H13.5756L3 13.5756Z" />
      <path d="M3 17.8182C3 17.8122 3 17.8061 3 17.8V15.6969L15.6969 3H17.8C17.8061 3 17.8122 3 17.8182 3L3 17.8182Z" />
      <path d="M4.22116 20.8397C4.17659 20.8224 4.13368 20.8032 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3.1968 19.8664 3.17768 19.8236 3.16041 19.7791L19.7791 3.16041C19.8236 3.17768 19.8664 3.1968 19.908 3.21799C20.2843 3.40973 20.5903 3.71569 20.782 4.09202C20.8032 4.13368 20.8224 4.17659 20.8397 4.22116L4.22116 20.8397Z" />
      <path d="M8.30349 21H6.2C6.19404 21 6.1881 21 6.18217 21L21 6.18217C21 6.1881 21 6.19404 21 6.2V8.30349L8.30349 21Z" />
      <path d="M12.5461 21H10.4248L21 10.4248V12.5461L12.5461 21Z" />
      <path d="M16.7888 21H14.6675L21 14.6675V16.7888L16.7888 21Z" />
      <path d="M20.985 18.9251C20.9633 19.3573 20.9106 19.6556 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.6556 20.9106 19.3573 20.9633 18.9251 20.985L20.985 18.9251Z" />
      <path d="M5.07527 3.01502L3.01502 5.07527C3.03664 4.6429 3.08937 4.34444 3.21799 4.09202C3.40973 3.71569 3.71569 3.40973 4.09202 3.21799C4.34444 3.08937 4.6429 3.03664 5.07527 3.01502Z" />
    </Icon>
  );
};
